import type { Location, NavigateFunction } from "react-router";

/** Kirgandan keyin qayerga: `state.from` (himoyalangan sahifadan kelgan) yoki `?next=` (Django admin kirishi shu yerga
 * yo'naltiradi, 2026-10-18); faqat nisbiy yo'l qabul qilinadi (tashqi manzilga olib chiqmaydi). */
export function postLoginTarget(location: Pick<Location, "state" | "search">): string {
  const from = (location.state as { from?: string } | null)?.from;
  const next = new URLSearchParams(location.search).get("next");
  const pick = from || next || "/";
  return pick.startsWith("/") && !pick.startsWith("//") ? pick : "/";
}

/** Django admin SPA'dan tashqarida -- to'liq sahifa o'tishi; qolgani router orqali */
export function goAfterLogin(target: string, navigate: NavigateFunction) {
  if (target.startsWith("/django-admin")) window.location.assign(target);
  else navigate(target, { replace: true });
}
